import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

interface AiImproveButtonProps {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
  label?: string;
  loadingLabel?: string;
}

export default function AiImproveButton({
  disabled,
  loading,
  onClick,
  label = "Improve with AI",
  loadingLabel = "Improving text...",
}: AiImproveButtonProps) {
  return (
    <button
      type="button"
      className="ai-improve-button"
      disabled={disabled || loading}
      onClick={onClick}
    >
      <AutoAwesomeIcon fontSize="small" />
      {loading ? loadingLabel : label}
    </button>
  );
}
